import {
  observable, autorun, runInAction, action, computed, makeObservable,
} from 'mobx';
import { PaginatedHistory } from '@src/types/comsApi';
import { ClientStore } from './ClientStore';

export class HistoryStore {
  client: ClientStore;

  public configId?: string = undefined;
  public data?: PaginatedHistory = undefined;
  public consentShortScope?: string = undefined;

  constructor(client: ClientStore) {
    makeObservable(this, {
      configId: observable,
      data: observable,
      gotoPage: action,
      currentPage: computed,
    });

    this.client = client;

    autorun(() => {
      if (this.configId) {
        this.data = undefined;
        // eslint-disable-next-line no-void
        void this.gotoPage(1);
      }
    });
  }

  private async loadPage(offset: number): Promise<void> {
    const data = await this.client.getConsentHistory(
      this.configId as string,
      offset,
      5, // max page size
    );
    runInAction(() => {
      this.data = data;
    });
  }

  public async gotoPage(goto = 1): Promise<void> {
    const offset = this.data ? (goto - 1) * this.data.limit : 0;
    await this.loadPage(offset);
  }

  get currentPage(): number {
    if (!this.data) return 0;
    const { offset, limit } = this.data;
    return Math.floor(offset / limit);
  }
}
